module.exports = __webpack_public_path__ + "static/media/search-icon.c1a1cc16.svg";